module.exports = __webpack_public_path__ + "prod/1.42.2/img/qianhui-icon.cff03668.png";